import { optionTitle_storage } from 'owa-locstrings/lib/strings/optiontitle_storage.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
// This will be removed after PremiumDashboardApril is rolled out.
let StorageOption: LazyOption = createLazyOption(
    {
        key: 'StoragePremium',
        titleStringKey: optionTitle_storage,
        searchTermsStringKey: optionTitle_storage,
        isHidden: () =>
            isFeatureEnabled('auth-PremiumDashboardApril') ||
            !isFeatureEnabled('auth-PremiumDashboard') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
let StorageOptionApril: LazyOption = createLazyOption(
    {
        key: 'StoragePremium_',
        titleStringKey: optionTitle_storage,
        searchTermsStringKey: optionTitle_storage,
        isHidden: () =>
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default StorageOption;
export { StorageOptionApril };
